
export default {
	name: 'DeleteScheduleStudent',
};
